//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
// import PhoneBinding from './components/phoneBinding.vue'
// import FooterBar from './components/FooterBar.vue'
import PaymentPrompt from './components/PaymentPrompt.vue'
import BackGuide from './components/backGuide.vue'

export default {
    name: 'app',
    data: function () {
        return {
            wxName: '',
            orShowFooterBar: false,
            footerSelectBar: '',
            closeGuideModal: false,
            suspensionModal: false,
            backValue: 0,
        }
    },
    components: {
        // PhoneBinding,
        // FooterBar,
        PaymentPrompt,
        BackGuide
    },
    computed: {
        ...mapState({
            isLoading: state => state.isLoading,
            direction: state => state.direction,
            bindingPhoneType: state => state.bindingPhoneType,
            dtFrom: state => state.dtFrom,
            paymentPromptStatus: state => state.paymentPromptStatus
        }),
        viewTransition () {
            if (!this.direction) return ''
            return 'vux-pop-' + (this.direction === 'forward' ? 'in' : 'out')
        }
    },
    watch: {
        // 监测路由
        $route: function (to, from) {
            // 判断是否带有app标识
            // if (to.query.dt_from && to.query.dt_from === 'app') {
            //   if (!this.dtFrom) {
            //     this.$store.commit('SET_DT_FROM', to.query.dt_from)
            //     // 存储app来源设备信息
            //     // this.$store.commit('SET_APP', JSON.parse(sessionStorage.getItem('dtFromData').app))
            //   }
            // } else {
            //   if (!this.dtFrom) {
            //     this.$store.commit('SET_DT_FROM', null)
            //     this.$store.commit('SET_APP', null)
            //     // 校验是否有绑定手机号码
            //     // this.verifyMobile()
            //   }
            // }

            // const footerType = to.meta.footerType
            // 设置底部导航状态
            // const name = to.name
            // if (name) {
            //   const ars = name.split('.')
            //   if (ars[0] === 'index' || ars[0] === 'subscribe' || ars[0] === 'study' || ars[0] === 'user') {
            //     this.footerSelectBar = ars[0]
            //   } else {
            //     this.footerSelectBar = ''
            //   }
            // }
            // 是否全局添加底部导航
            // if (footerType) {
            //   this.orShowFooterBar = true
            // } else {
            //   this.orShowFooterBar = false
            // }
            // 修改背景颜色
            var $app = document.getElementById('app');
            if(to.name == 'index.index') {
                $app.style.overflow = 'scroll';
            } else {
                $app.style.overflow = ''
            }
            const bgColor = to.meta.bgColor;
            const name = to.name;
            //if(name == 'course.courseIndex' || name == 'expert.expertDetail' || name == 'expert.expertArticle') {
            if(name == 'expert.expertDetail' || name == 'expert.expertArticle') {
                this.suspensionModal = true;
            } else {
                this.suspensionModal = false;
            }
            if (bgColor) {
                document.body.style.backgroundColor = '#' + bgColor
            } else {
                document.body.style.backgroundColor = '#ffffff'
            }
        }
    },
    created () {
        // 判断当前路由是否为微信分享落地页
        // const wxRouteName = sessionStorage.getItem('wxRouteName')
        // if (wxRouteName === null) {
        //   this.getClientUserInfo()
        // }
        this.getClientUserInfo();
        this.addNativeEvent()
    },
    methods: {
        // 监听native事件
        addNativeEvent: function() {
            let that = this;
            window.lisenNative('refreshToken',function(data) {
                var user;
                try {
                    user = JSON.parse(window.localStorage.getItem('user'));
                } catch (error) {

                }
                if(user && user.data){//缓存中存有用户信息，更新缓存中的token
                    user.data.token = data.token
                    window.localStorage.setItem('user', JSON.stringify(user));
                }
            });
            let urlParams = this.getUrlParams('guide');
            if(urlParams) {
                this.$sdk.beacon.setBackButtonListenerEnable({//接管返回按钮
                   enable: 1
               }, function() {});
               window.lisenNative('clickBtn',function(options) {
                   if(options.type == 'backButton') {
                       const value = that.$store.state.guideShow;
                       if(value == 2) {
                           // 直接关闭
                           that.$sdk.beacon.closeWindow({},function () {})
                       } else {
                           that.closeGuideModal = true;
                           that.$burialPoint.addEvent('entry.show');
                           var $app = document.getElementById('app');
                           $app.style = 'overflow:hidden';
                           if(that.backValue >= 1) {
                               // 直接关闭
                               var $app = document.getElementById('app');
                               $app.style = '';
                               that.$sdk.beacon.closeWindow({},function () {})
                           }
                           that.backValue++;
                       }
                   }
               })
            }
        },
        getUrlParams: function(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            var r = location.search.substr(1).match(reg);
            if (r != null) return unescape(decodeURI(r[2]));
            return null;
        },
        handleBackHome: function() {
            const url = location.origin + '/investor-education-manager/wap?dt_from=app';
            const jumpUrl = 'beacon://web?url='+encodeURIComponent(url) + '&cacheNone=1&cacheClose=1';
            this.$burialPoint.addEvent('float.home',{
                    to_resourceid: 'course_room_page',
                    to_framied:'course_room_1.0.0',
                },jumpUrl,1);
            // 返回首页
            /*this.$router.replace({
                name: 'index.index',
            })*/
        },
        // 获取客户端用户信息
        getClientUserInfo () {
            this.$sdk.beacon.getAccountInfo({}, data => {
                window.localStorage.setItem('accountInfo', JSON.stringify(data));
                if (data.AID !== 0) {
                    this.$store.commit('SET_USER_ID', data.AID)
                }
                if (data.ticket !== '') {
                    this.$store.commit('SET_USER_TICKETD', data.ticket)
                }
                if (data.AID !== 0 && data.ticket !== '') {
                    this.changeManagerLogin(data)
                } else {
                    this.mangerLogoutLogin()
                }
                this.$store.commit('SET_APP', data.app)

                if (data.app === 'android') {
                    this.setTitleBar()
                }
            })
        },
        // 设置标题栏背景颜色
        setTitleBar () {
            let that = this;
            this.$util.getVersion().then(function (ver) {
                let version = that.$util.judgeVersionEnough('3.3.0',ver);
                let option = [];
                if(version) {
                    option = [
                        // {'viewType': 'backButton', 'visibility': 1, color: '255, 255, 255, 1', word: '', position: 'left'},
                        // {'viewType': 'titleBar', color: '253, 119, 54, 1', position: 'middle'}
                        {'viewType': 'backButton', 'visibility': 1, color: '37, 37, 37, 1', word: '', position: 'left'},
                        {'viewType': 'titleBar', color: '255, 255, 255, 1', position: 'middle'}
                    ]
                } else {
                    option = [
                        {'viewType': 'backButton', 'visibility': 1, color: '255, 255, 255, 1', word: '', position: 'left'},
                        {'viewType': 'titleBar', color: '253, 119, 54, 1', position: 'middle'}
                        // {'viewType': 'backButton', 'visibility': 1, color: '37, 37, 37, 1', word: '', position: 'left'},
                        // {'viewType': 'titleBar', color: '255, 255, 255, 1', position: 'middle'}
                    ]
                }
                that.$sdk.beacon.setWebViewTitleBar(option, function () {})
            });
        },
        // 股掌柜退出登录
        mangerLogoutLogin () {
            this.$api.common.managerLogoutLogin(res => {})
        },
        // 更改股掌柜登录令牌
        changeManagerLogin (obj) {
            let data = {
                login_type: 5,
                user_id: obj.AID,
                ticket: obj.ticket,
                login_from: ''
            }
            if (obj.app === 'ios') {
                data['login_from'] = 2
            } else {
                data['login_from'] = 3
            }
            this.$api.common.managerTicketLogin(data, res => {
                if (res.code === 0) {
                    this.$store.commit('SET_USER_INFO', res.data)
                } else {
                    this.$vux.toast.show('登录失败')
                }
            })
        },
        // 校验是否有绑定手机号码
        verifyMobile () {
            const dtFromData = JSON.parse(window.sessionStorage.getItem('dtFromData'))
            if (dtFromData !== null) {
                return false
            }
            this.wxName = '';
            this.$api.common.orVerifyMobile(res => {
                if (res.code === 0) {
                    if (res.data.exist_mobile === 0) {
                        this.$store.commit('OPEN_BINDING_PHONE_MODEL')
                        this.wxName = res.data.nick_name;
                        this.$vux.loading.hide()
                    }
                } else {
                    this.$vux.toast.show('获取绑定电话状态失败，请重新刷新页面')
                }
            })
        },
        handleCloseGuide: function (data) {
            this.closeGuideModal = false;
            var $app = document.getElementById('app');
            $app.style = '';
            if(data == 2) {
                // 关闭弹框并返回
                this.$sdk.beacon.closeWindow({},function () {})
            } else {
                // 关闭弹框
                this.$store.commit('UPDATE_BACK',2)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/App.vue